export default __webpack_public_path__ + "static/media/pure-entertainment-bg.55ef3cc4.png";